import Photo from '@alltrails/types/Photo';
import PhotoSizeDimensions from '@alltrails/types/PhotoSizeDimensions';

const photoHostName = process.env.NEXT_PUBLIC_PHOTO_HOST_NAME ?? 'images.alltrails.com';
const photoBucketName = process.env.NEXT_PUBLIC_PHOTO_BUCKET_NAME ?? 'assets.alltrails.com';

type BannerPhotoSizeDimensions = '2044x624' | '1022x312' | '3520x1600' | '2232x1257' | '1488x838' | '744x419';
export type PhotoSize = PhotoSizeDimensions | BannerPhotoSizeDimensions;
type Fit = 'contain' | 'cover' | 'fill' | 'inside' | 'outside';

// Relic from the monorepo - maybe we want this configurable in the future, but for now, we maintain this automatic behavior
const insideFitSizes: PhotoSize[] = ['100x100', '200x200', '500x500', '2048x2048'];

// See the ServerlessImageHandler for details on accepted args https://github.com/alltrails/alltrails/blob/alpha/app/services/serverless_image_handler/resizer.rb
type Args = {
  fit?: Fit;
  isOptimized?: boolean;
  photo: Photo;
  size: PhotoSize;
};

const getPhotoUrl = ({ fit, isOptimized = false, photo, size }: Args): string => {
  const { id, photoHash } = photo;
  const defaultFit = insideFitSizes.includes(size) ? 'inside' : 'cover';
  const [width, height] = size.split('x');

  // Warning: Changing this has $$$ implications! Photos are cached on CloudFront using this Base64-encoded
  // object as the key. Cache misses go to Lambda to regenerate photos.
  const imageJson = JSON.stringify({
    bucket: photoBucketName,
    key: `uploads/photo/image/${id}/${photoHash}.jpg`,
    edits: {
      toFormat: isOptimized ? 'webp' : 'jpeg',
      resize: { width, height, fit: fit ?? defaultFit },
      rotate: null,
      jpeg: { trellisQuantisation: true, overshootDeringing: true, optimiseScans: true, quantisationTable: 3 }
    }
  });

  return `https://${photoHostName}/${btoa(imageJson)}`;
};

export default getPhotoUrl;
